jQuery(document).ready(function($) {
  var $body = $('body');
  let lastFocus;
  var $assetUrl = '//uk.morphe.com/cdn/shop/t/660/assets/ad.svg?52891';
  var $countries =[];

  var $countryButton = $('.announcement-bar__country-selector, .new-header__mobile-country-selector'),
      $regionSearch = $('.region-search'),
      $regionSearchInput = $('.region-search__search'),
      $countriesList = $('.region-search__countries'),
      $siteMenu = $('.new-header__mobile-nav-container'),
      $burgerIcon = $('.new-header__hamburger-icon'),
      $footerCountrySelector = $('.new-footer-bottom-bar__country-selector'),
      urlUS_PROD = "morphe.com",
      urlCA_PROD = "ca.morphe.com",
      urlUK_PROD = "uk.morphe.com",
      urlEU_PROD = "eu.morphe.com",
      urlAU_PROD = "au.morphe.com",
      locationUrl = window.location.origin;


  if (locationUrl.indexOf(urlUS_PROD) == -1 && locationUrl.indexOf(urlCA_PROD) == -1 && locationUrl.indexOf(urlUK_PROD) == -1 && locationUrl.indexOf(urlEU_PROD) == -1 && locationUrl.indexOf(urlAU_PROD) == -1) {
    var $linkCloseDev = true;
  }


  function getURLParameter(name) {
    return decodeURIComponent((new RegExp('[?|&]' + name + '=' + '([^&;]+?)(&|#|;|$)').exec(location.search) || [null, ''])[1].replace(/\+/g, '%20')) || null;
  }

  (function () {
  if (localStorage.getItem('country_select')) {
      var $selectedCountryCode = localStorage.getItem('country_select');

      
      
      $footerCountrySelector.find('span').html($selectedCountryCode);
      
    }
    $footerCountrySelector.css('visibility', 'visible');
    $countryButton.css('visibility', 'visible');
  })();

  getCountries('');

  $regionSearchInput.keyup(function () {
    var $value = $(this).val().toLowerCase();
    // $('.floating-label').addClass('has-focus')
    $('.floating-label').addClass('is-floating');
    getCountries($value);
  });
  $regionSearchInput.focusout(function (e) {
    // $('.floating-label').removeClass('has-focus')
    if(e.target.value == '') {
      $('.floating-label').removeClass('is-floating');
    }
   
  });


  $countryButton.on('click', function(e){    
    e.preventDefault();
    //load countries if not loaded.
    if (!$countries.length ){
      //load countries.
      $.getJSON( "//uk.morphe.com/cdn/shop/t/660/assets/countries.json?v=156389647764080223541747155227", function() {        
      })
        .done(function(data) {
          $countries = data;         
          getCountries('');
        })
      //load flags map.
    
    $.ajax({
      url: "//uk.morphe.com/cdn/shop/t/660/assets/countries.svg?v=180026656107692894581747155228",
      dataType: 'html',
      type: 'GET' 
    })
      .done(function(data) {
        $("#svgph").append( data );
      });
    }

    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    

    $regionSearch.fadeToggle(500);
    $countryButton.toggleClass('open');
    $regionSearchInput.focus();

  });

  $footerCountrySelector.on('click keypress', function (e) {
    e.preventDefault();
    $('.new-header__hamburger-icon .new-header__cart-icon').addClass('open');
    lastFocus = document.activeElement;
    $regionSearch.fadeToggle(500);
    $countryButton.toggleClass('open');
    $regionSearchInput.focus();
  });

  $(document).keydown(function(e) {
    var $regionSearch = $('.region-search');
    var $searchBar = $('#search_morphe');
    const $firstFocusableElement = document.querySelector('.region__close');
    const $lastFocusableElement = document.querySelector('.region-search__country:last-child .country__link');
    if (e.keyCode == 27) {
      if ($regionSearch.is(':visible')) {
        $regionSearch.fadeOut(500);
        $countryButton.focus();
      } else if ($searchBar.is(':visible')) {
        $searchBar.fadeOut(500);
        $searchIcon.focus();
      }
      $body.removeClass('fixed');
    }
    if (e.target == $firstFocusableElement && e.key == 'Tab' && e.shiftKey) {
      e.preventDefault();
      $lastFocusableElement.focus();
    } else if(e.target == $lastFocusableElement && e.key == 'Tab' && !e.shiftKey) {
      e.preventDefault();
      $firstFocusableElement.focus();
    }
  });

  $('.region__close').on('click', function(e){
    var $regionSearch = $('.region-search');
      if ($regionSearch.is(':visible')) {
        $regionSearch.fadeOut(500);
        $countryButton.focus();
      } else if ($searchBar.is(':visible')) {
        $searchBar.fadeOut(500);
        $searchIcon.focus();
      }
      $body.removeClass('no-overflow');
  });

  function getCountries(value) {
    var $countriesArray = [],
        $countryEmptyMessage = '<p class="country__not-found">Country <strong>' + value + '</strong> not found</p>';

    $.each($countries, function(i, item) {
      var $countryName = item.name.toLowerCase(),
          $itemUrl = 'https://' + item.url,
          $linkClose = '',
          $itemCode = item.code.toLowerCase(),
          $itemAltname = item.altname.toLowerCase(),
          $imageUrl = $assetUrl.split('ad.svg')[0] + $itemCode + '.svg' + $assetUrl.split('ad.svg')[1];

      if (window.location.origin.indexOf(item.url) > -1) {
        $linkClose = 'close-region-search';
      }
      if (item.url.indexOf(urlUS_PROD) > -1 && $linkCloseDev ) {
        $linkClose = 'close-region-search';
      }      
      if ($countryName.indexOf(value) != -1 || $itemCode.indexOf(value.toLowerCase()) !=-1 || $itemAltname.indexOf(value.toLowerCase()) !=-1 ) {
        
        var $countryItem = '<li role="option" class="region-search__country country" data-code="' + $itemCode + '">' +
                '<a href="' + $itemUrl +'?country='+ $itemCode + '" data-country-code="'+ $itemCode +'" class="country__link '+ $linkClose +'">' +
                '<div class="flag"><svg style="width: 28px; height: 20px;" aria-hidden="true"><use xlink:href="#'+ $itemCode +'" /></svg></div>' +
                '<span class="country__name">' + truncateWords(item.name, 4) + '</span>' +
                '<span class="country__currency">' + item.currency + '</span>' +
                '</a>' +
                '</li>';

        $countriesArray.push($countryItem);
      }
    });
    if (!$countriesArray.length) {
      $countriesArray.push($countryEmptyMessage)
    }
    $countriesList.html($countriesArray.join(' '));
  }

  function truncateWords(string, maxWords) {
    var strippedString = $("<p>" + string + "</p>").text().trim();
    var array = strippedString.split(" ");
    var wordCount = array.length;
    var string = array.splice(0, maxWords).join(" ");
    if(wordCount > maxWords) {
      string += "...";
    }
    return string ;
  }

  $(document).mouseup(function(e) {
    var $searchCointainer = $('.region-search > .wrapper, .announcement-bar__country-selector, #search_morphe, .snize-ac-results');

    if (!$searchCointainer.is(e.target) && $searchCointainer.has(e.target).length === 0 && !$countryButton.is(e.target)) {
      window.setTimeout(function() {
        $regionSearchInput.val('');
      }, 500);
      $regionSearch.fadeOut(500);
      $body.removeClass('fixed');
    }
  });
  
  $(document).on('click', '.country__link', function (e) {
    e.preventDefault();

    var countryCode = $(this).data('country-code');
    var countrySiteUrl = $(this).attr('href');

    localStorage.setItem('country_select', $(this).data('country-code'));

    if ($(this).hasClass('close-region-search')) {
      window.setTimeout(function() {
        $regionSearchInput.val('');
      }, 500);
      
      
      $footerCountrySelector.find('span').html(countryCode);
      $regionSearch.fadeOut(500);
      $body.removeClass('fixed');
    } else {
        localStorage.removeItem('country_select');
        window.location = countrySiteUrl;
    }
  })
});
